export default __webpack_public_path__ + "static/media/Virtual-Community.7152af76.png";